module.exports = __webpack_public_path__ + "img/3d2341e.png";